module.exports = __webpack_public_path__ + "img/img-sitio-anter_cotizacion_globo.79d8bc37.svg";